<div class="comment-box">
  <div class="comment-box__header">
    @if (isFirstLoaded) {
      <mat-tab-group
        [selectedIndex]="selectedChannelIndex"
        (selectedTabChange)="onChangeChannel($event)"
        >
        @if (!onlyProperties && hasCommentPermission) {
          @for (channel of listChannel; track channel.value) {
            <mat-tab [label]="channel.label"></mat-tab>
          }
        }
        @if (authService.hasPermission(Permission.ProductsFull)) {
          <mat-tab label="PROPERTIES"></mat-tab>
        }
        @if (authService.hasPermission(Permission.ProductsLabelData) && assetType != 'output-asset' && currentAsset.type == 'Still') {
          <mat-tab
            label="LABEL"
          ></mat-tab>
        }
      </mat-tab-group>
    }
  </div>

  @if (propertiesView || onlyProperties) {
    <app-properties-view
      [assetDetail]="assetDetail"
      [assetType]="assetType"
      [contentExtracting]="contentExtracting"
      (boundingBoxProportionEmitter)="boundingBoxProportionEmitter.emit($event)"
      (contentExtractingEmitter)="contentExtractingEmitter.emit($event)"
    ></app-properties-view>
  }

  @if (labelView) {
    <div class="comment-box__label-view">
      <app-label-display
        [assetDetail]="assetDetail"
        [assetType]="assetType"
      ></app-label-display>
    </div>
  }

  @if (!propertiesView && !labelView && !onlyProperties && hasCommentPermission) {
    <app-discussion-view
      [currentAsset]="currentAsset"
      [assetDetail]="assetDetail"
      [assetType]="assetType"
      [productTouchAssetId]="productTouchAssetId"
      [masterSuiteTouchAssetId]="masterSuiteTouchAssetId"
      [organizationId]="organizationId"
      [currentChannel]="currentChannel"
      [commentBoundingBox]="commentBoundingBox"
      (versionSelected)="versionSelected.emit($event)"
      (commentHover)="commentHover.emit($event)"
      (clearBoundingBox)="clearBoundingBox.emit()"
    ></app-discussion-view>
  }
</div>
